export const namespaced = true;

export const state = {
    types: [],
    allTypes: [],
    meta: null,
    page: 1,
    per_page: 25,
    type: {},
    currentModel: '',
    currentGroupId: 0,
    add: false,
    edit: null,
    loading: false,
}

export const mutations = {
    FETCH_TYPES(state, types) {
        state.types = types;
    },

    FETCH_ALL_TYPES(state, allTypes) {
        state.allTypes = allTypes;
    },

    FETCH_META(state, meta) {
        state.meta = meta;
    },
    ADD_TYPE(state, material) {
        state.materials.unshift(material);
    },
    FETCH_TYPE(state, type) {
        state.type = type;
    },
    SET_ADD_FORM(state, add) {
        state.add = add;
    },
    SET_EDIT_FORM(state, edit) {
        state.edit = edit;
    },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    SET_CURRENT_MODEL_AND_GROUP_ID(state, { currentModel, currentGroupId }) {
        state.currentModel = currentModel;
        state.currentGroupId = currentGroupId;
    },
    TYPE_REMOVE(state) { },
    TYPE_BLOCK(state) { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/types`, {
                params: {
                    model: state.currentModel,
                    group_id: state.currentGroupId || null,
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_TYPES', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchAll({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/types-all`, {
                params: {
                    model: state.currentModel,
                    group_id: state.currentGroupId || null,

                }
            }));
            commit('FETCH_ALL_TYPES', res.data.data);
            return res.data.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchType({ commit, dispatch }, type_id) {
        try {
            const res = (await axios.get(`/api/admin/types/${type_id}`)).data;
            const type = res?.data?.type;
            commit('FETCH_TYPE', type);
            return type;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error;
        }
    },

    setAdd({ commit }, add) {
        commit('SET_ADD_FORM', add);
    },

    setEdit({ commit }, edit) {
        commit('SET_EDIT_FORM', edit);
    },

    setCurrentModelAndGroupId({ commit }, { currentModel, currentGroupId }) {
        commit('SET_CURRENT_MODEL_AND_GROUP_ID', { currentModel, currentGroupId });
    },

    setPage({ commit, dispatch }, page) {
        commit('SET_PAGE', page);
        dispatch('fetch');
    },

    setPerPage({ commit, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        dispatch('fetch');
    },

    async block({ commit, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-types`, formDataPost
                    )
                ).data;

                commit('TYPE_BLOCK');

                dispatch('fetch');

                const notification = {
                    type: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    type: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                type: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-types`, formDataPost
                    )
                ).data;
                commit('TYPE_REMOVE');

                dispatch('fetch');

                const notification = {
                    type: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    type: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                type: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },





}
